import React from "react";
import PageContainer from "../components/pageContainer/PageContainer";
import SettingsLayout from "../components/settings/SettingsLayout";
import useTitle from "../hooks/TitleManager";
import useSettingsTimeManagement from "../hooks/useSettingsTimeManagement";

import BreaksBlock from "../components/timeManagement/BreaksBlock";
import TimeCutBlock from "../components/timeManagement/TimeCutBlock";
import PdnsBlock from "../components/timeManagement/PdnsBlock";
import SundayHoursBlock from "../components/timeManagement/SundayHoursBlock";

const SettingsTimeManagement = () => {
  useTitle({ title: "Paramètres - Heures & Majoration" });

  const {
    timeCut,
    breaks,
    isWaiting,
    commitTimeCut,
    commitBreaks,
    isPdnsDisplay,
    companiesPdns,
    commitPdns,
    isSundayHoursDisplay,
    companiesSundayHours,
    commitSundayHours,
  } = useSettingsTimeManagement();

  return (
    <PageContainer type="settings_time_management">
      <SettingsLayout>
        <div className="flex w-full flex-col gap-8">
          <h1 className="ft-xl font-semibold text-gray-900 pl-4">
            Heures & Majoration
          </h1>

          <section className="overflow-hidden bg-white">
            <TimeCutBlock
              timeCut={timeCut}
              isWaiting={isWaiting}
              onCommitTimeCut={commitTimeCut}
            />
          </section>

          <section className="flex flex-col gap-3">
            <h2 className="text-base font-semibold text-gray-900 pl-4">
              Peopulse
            </h2>
            <div className="overflow-hidden bg-white">
              <BreaksBlock
                breaks={breaks}
                isWaiting={isWaiting}
                onCommitBreaks={commitBreaks}
              />
              {isPdnsDisplay && (
                <PdnsBlock
                  isPdns={companiesPdns[0]?.isPdns ?? false}
                  isWaiting={isWaiting}
                  onCommitPdns={commitPdns}
                />
              )}
              {isSundayHoursDisplay && (
                <SundayHoursBlock
                  isSundayHours={companiesSundayHours[0]?.isSundayHours ?? false}
                  isWaiting={isWaiting}
                  onCommitSundayHours={commitSundayHours}
                />
              )}
            </div>
          </section>
        </div>
      </SettingsLayout>
    </PageContainer>
  );
};

export default SettingsTimeManagement;
